<template>
  <div>
    <Loader :loaded="departmentLoaded" :marginTop="25" />
    <XsDepartment v-if="$vuetify.breakpoint.xsOnly" :department="department" />
    <Department v-else :department="department" />
  </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import Loader from "@/components/UI/Loader.vue";
import Department from "@/components/Department/Department.vue";
import XsDepartment from "@/components/Department/Xs/Department.vue";

export default {
  name: "DepartmentView",
  components: { Department, Loader, XsDepartment },
  computed: {
    ...mapGetters("department", {
      departmentLoaded: "loaded",
    }),
    ...mapState({
      department: (state) => state.department.data,
    }),
  },
  watch: {
    $route: {
      handler: function ({ hash, params }) {
        if (hash) {
          return;
        }
        this.$store.dispatch("department/fetch", params.departmentId);
      },
      deep: true,
      immediate: true,
    },
  },
};
</script>
